<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.product_config">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div *ngIf="wrappers">
    <div class="banner center" style="max-width:1400px;">
      <div class="row freeze_height">
        <div class="col-md-4">
          <div style="max-width: 300px;">
            <ngx-select [(ngModel)]="selectedProductEntryType" [noAutoComplete]="true" [items]="productEntryTypes"
              [optionValueField]="'key'" [optionTextField]="'value'" (select)="onLoad()">
            </ngx-select>
          </div>
        </div>
        <div class="col-md-4">
          <div style="max-width: 300px;" *ngIf="productCategories.length > 0">
            <ngx-select [(ngModel)]="selectedProductCategory" [noAutoComplete]="true" [items]="productCategories"
              [optionValueField]="'key'" [optionTextField]="'v1'" (select)="onLoad()" [allowClear]="true"
              (remove)="onLoad()" [placeholder]="localService.languageContent.product_config.category_for_quick_pick">
            </ngx-select>
          </div>
        </div>
        <div class="col-4">
          <div class="icon_action_header">
            <button class="button_icon button_icon_color icon_adjust on_language_changed" style="margin-left: 10px;"
              (click)="onLoad(true)">replay_circle_filled</button>
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
              (click)="onAction(4)">add_shopping_cart</button>
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
              (click)="onGenerateBarCode()"
              [disabled]="!(wrappers && wrappers.items.length > 0)">qr_code_scanner</button>
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
              (click)="onAction(2)">history</button>
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;" (click)="onAction(7)"
              title="{{localService.languageContent.product_config.custom_fields}}">dashboard_customize</button>
            <button class="button_icon button_icon_color" style="top: 5px;" (click)="onAction(9)">
              more_horiz
            </button>
          </div>
        </div>
      </div>
      <div class="row freeze_height">
        <div [ngClass]="isInventoryEnabled ? 'col-md-8' : 'col-12'">
          <label style="font-weight: normal; margin-left: 15px;">
            <input type="checkbox" [(ngModel)]="isInventoryEnabled" (change)="onEnableDiableStock()" />
            <span class="normal_color">{{localService.languageContent.product_config.enable_invent}}</span>
          </label>
        </div>
        <div class="col-md-4" *ngIf="isInventoryEnabled">
          <label style="font-weight: normal; margin-left: 15px;">
            <input type="checkbox" [(ngModel)]="isOnlyLessStock" (change)="onLoad()" />
            <span class="normal_color">{{localService.languageContent.product_config.only_less_stock}}</span>
          </label>
        </div>
      </div>
      <div class="row freeze_height" *ngIf="isInventoryEnabled && lessStockMessage">
        <div class="col-12">
          <span style="color:red">{{lessStockMessage}}</span>
        </div>
      </div>
      <div class="row row_header freeze_col freeze_height">
        <div [ngClass]="isInventoryEnabled ? 'col-md-8' : 'col-md-12'">
          <div class="row">
            <div [ngClass]="isInventoryEnabled ? 'col-5' : 'col-3'">
              {{localService.languageContent.table.action}}
            </div>
            <div [ngClass]="isInventoryEnabled ? 'col-7' : 'col-9'">
              {{localService.languageContent.table.title}}
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="isInventoryEnabled">
          <div class="row">
            <div [ngClass]="isDirectStockDisabled ? 'col-12' : 'col-6'">
              {{localService.languageContent.table.stock}}
            </div>
            <div class="col-6" *ngIf="!isDirectStockDisabled">
              {{localService.languageContent.common.add}}
            </div>
          </div>
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row freeze_col" *ngFor="let item of wrappers.items">
          <div [ngClass]="isInventoryEnabled ? 'col-md-8' : 'col-md-12'">
            <div class="row">
              <div [ngClass]="isInventoryEnabled ? 'col-5' : 'col-3'">
                <i *ngIf="!isImageUploadEnabled" class="material-icons icon_adjust disabled-icon">image</i>
                <button class="button_icon button_icon_color icon_adjust"
                  (click)="onAction(10,item.key,item.v14,item.v1,item.v4)"
                  title="{{localService.languageContent.product_config.raw_inventory}}">inventory</button>
                <button *ngIf="isImageUploadEnabled" class="button_icon button_icon_color icon_adjust"
                  (click)="onUploadImage(item.key)">image</button>
                <button class="button_icon button_icon_color icon_adjust" [disabled]="!hasValidBatchDetails"
                  (click)="onAction(6,item.key)">batch_prediction</button>
                <button class="button_icon button_icon_color icon_adjust" [disabled]="item.v7 == '0'"
                  (click)="onAction(3,item.key)">history</button>
                <button class="button_icon button_icon_color icon_adjust" style="rotate: -90deg;"
                  (click)="onAction(8,item.key,item.v14,item.v1,item.v4)"
                  title="{{localService.languageContent.product_config.child_measurement_type}}">schema</button>
                <button class="button_icon icon_adjust"
                  title="{{item.v3 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                  (click)="onActiveInactiveStatus(item.key)"
                  [ngStyle]="{'color': item.v3 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v3 == '1' ? "toggle_on" :
                  "toggle_off"}}</button>
                <a class="button"
                  [routerLink]="['/serial-numbers', ctryCode, userId, interactionType, businessId, item.key, 0]"
                  *ngIf="item.v6 == '1'"><i class="material-icons button icon_adjust">numbers</i></a>
              </div>
              <div [ngClass]="isInventoryEnabled ? 'col-7' : 'col-9'">
                <div class="button" (click)="onAction(4,item.key)">
                  <span class="en">{{item.v4}} - </span>
                  <span [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" *ngIf="isInventoryEnabled">
            <div class="row">
              <div class="cost en" [ngClass]="isDirectStockDisabled ? 'col-12' : 'col-6'">
                <span>{{item.v5 | number: '1.2-2'}}</span>
              </div>
              <div class="col-6" *ngIf="!isDirectStockDisabled">
                <input autocomplete="off" type="number" class="number cost"
                  (keypress)="localService.isNumberOnly($event,numericConfig)"
                  placeholder="{{localService.languageContent.common.add}}"
                  title="{{localService.languageContent.common.add}}"
                  (keydown.enter)="onAddStock($event,item.key,item.v5)"
                  (focusout)="onAddStock($event,item.key,item.v5)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-paging *ngIf="wrappers && wrappers.paging" [paging]="wrappers.paging"
      (onPagingRefreshed)="onLoad()"></app-paging>
  </div>
</div>
<div *ngIf="wrappers">
  <app-gallery-config [(isOpenPopup)]="isGalleryPopupOpen" [galleryType]="2"
    [parentId]="selectedProductIdForImageUpload" [businessId]="businessId"
    (onClose)="onClosesGalleryPopup($event)"></app-gallery-config>
  <app-product-details [(isOpenPopup)]="isProductDetailPopupOpen" [businessId]="businessId"
    [selectedProductEntryType]="selectedProductEntryType" [customFields]="customFields"
    [isNotConsiderTax]="isNotConsiderTax" [businessTaxes]="businessTaxes" [productId]="selectedProductId"
    [isInventoryEnabled]="isInventoryEnabled" [businessTaxCategories]="taxCategories"
    (onClose)="onClosesProductDetailPopup($event)" [productLabels]="productLabels" />
  <app-custom-fields-config [(isOpenPopup)]="isOpenCustomFields" [countryCode]="ctryCode" [businessId]="businessId"
    (onClose)="onSetCustomFields()" />
  <app-product-child-measurement [(isOpenPopup)]="isOpenChildMeasurement" [countryCode]="ctryCode"
    [productId]="selectedProductId" [measurementType]="selectedMeasurementType" [businessId]="businessId"
    [isNotConsiderTax]="isNotConsiderTax" [isExcludePrice]="isExcludePrice" [productName]="selectedProductName"
    [productCode]="selectedProductCode" [businessTaxCategories]="taxCategories"
    [selectedBusinessTaxCategoryId]="selectedTaxCategoryId" />
  <app-products-action [(isOpenPopup)]="isActionPopupOpen" [businessId]="businessId" [businessName]="businessName"
    [ctryCode]="ctryCode" [paging]="wrappers.paging" />
  <app-raw-material-inventory-config [(isOpenPopup)]="isRawMaterialInventoryConfigOpen" [countryCode]="ctryCode"
    [productId]="selectedProductId" [measurementType]="selectedMeasurementType" [businessId]="businessId"
    [productCode]="selectedProductCode" [productName]="selectedProductName"
    [isRawInventoryEnabled]="isRawInventoryEnabled" (onClose)="onLoad()" />
</div>

<div *ngIf="wrappers && wrappers.items">
  <app-qr-label-preview-settings *ngIf="selectedTemplateFor && selectedTemplateFor > 0"
    [(isOpenPopup)]="isOpenLabelPreviewSettings" [countryCode]="ctryCode" [businessId]="businessId"
    [templateFor]="selectedTemplateFor" (onHtmlGenerated)="onHtmlGenerated($event)" [filterData]="filterData" />
  <app-html-viewer [isPopUp]="true" [isIframe]="true" [printHtml]="printHtml" (onClose)="printHtml = undefined" />
</div>